import React, {Component} from 'react';
import {Link} from "react-router-dom";
import './DataCreationAndUpload.css'
import FocusPageId from "../../FocusPageId";

let i = 0;

class DataCreationAndUpload extends Component {
    componentDidMount() {
        // window.scrollTo(0, 0);
        let element = document.getElementById(FocusPageId.selectedId.elementId);
        element.scrollIntoView(true);
        element.classList.add('mystyle');
        // element.style.paddingTop="50px"
        window.scrollTo({
            top: document.getElementById(FocusPageId.selectedId.elementId).offsetTop - 40,
            behavior: 'smooth'
        });

    }

    constructor(props) {
        super(props);

        this.positionAdject = this.positionAdject.bind()
    };

    positionAdject = () => {
        i++;
        // if(i<3){
        //     document.getElementById(FocusPageId.selectedId.elementId).style.paddingTop="0px";

        // }

    };

    render() {

        return (
            <div className="static-pages" onWheel={() => this.positionAdject()}>
                <div className="background-div">
                    <h3><b>
                        <li>データ作成・アップロードについて</li>
                    </b></h3>
                    <div className="brElement"></div>
                    <h4 id="a"><b> いつガーバーファイルをアップロードすればいいですか？</b>
                    </h4>
                    <p className='all-content-font-size'>基板製造見積り画面、右側にて表示されております注文内容に承諾後、ガーバーファイルをアップロードしてください。
                    </p>
                    <p className='all-content-font-size'> ガーバーファイルをアップロード後、“カートに保存”をクリックしてください。
                    </p>
                    <p className='all-content-font-size'> ガーバーファイルがアップロードされていない状態では、注文内容がカートに保存されません。
                    </p>
                    <div className="brElement"></div>
                    <h4 id="b"><b>前回のガーバーデータに、修正を加えて注文することが可能ですか？</b>
                    </h4>
                    <p className='all-content-line-height all-content-font-size'>過去に製造したガーバーデータに修正がございます場合は、お客様にてデータ修正いただき、新規にデータアップロード、
                        <div className="brElement"></div>ご注文をお願いいたします。リピート注文はデータの差し替えはできかねますので修正がある場合は、リピート注文はご利用
                        <div className="brElement"></div>いただけません。
                    </p>


                    <div className="brElement"></div>
                    <h4 id="c"><b>営業時間外、休業日にガーバーファイルをアップロードしても構いませんか？</b>
                    </h4>
                    <p className='all-content-font-size'>ガーバーファイルのアップロード・注文は24時間受付しておりますが、データーチェックについては
                    </p>
                    <p className='all-content-font-size'> 平日の9：00 ～ 18：00（HKT/GMT+8）になります。
                    </p>
                    <p className='all-content-font-size'> ※現在の日本と香港との時差は、1時間です。日本の方が、1時間進んでいます。
                    </p>
                    <p className='all-content-font-size'> 但し、弊社の定める休業日を除きます。
                        <Link to="/calendar">
                            <span className="pages-a-links">営業カレンダー</span></Link>
                        {/*にリンクさせてください*/}
                    </p>
                    <div className="brElement"></div>
                    {/*  <h4  id="d"> <b>・　推奨されるガーバー出力ファイル名</b>
                    </h4>*/}

                    {/*<p className='all-content-font-size'> ・　推奨されるガーバー出力ファイル名*/}
                    {/*</p>*/}


                    {/*<br/>*/}
                    {/*<p  className='all-content-font-size'>・　KiCADからのガーバー出力方法*/}
                    {/*</p>*/}

                    {/*<br/>*/}
                    {/*<p  className='all-content-font-size'>・　EAGLEからのガーバー出力方法*/}
                    {/*</p>*/}

                    {/*<br/>*/}
                    {/*<p  className='all-content-font-size'>・　Altiumからのガーバー出力方法*/}
                    {/*</p>*/}

                    {/*<br/>*/}
                    {/*<p  className='all-content-font-size'>・　OrCADからのガーバー出力方法*/}
                    {/*</p>*/}

                    {/*<br/>*/}
                    {/*<p  className='all-content-font-size'>・　Allegroからのガーバー出力方法*/}
                    {/*</p>*/}


                    <Link to="/footerNavPage4" target='_blank'>

                        推奨されるガーバー出力ファイル名

                    </Link>
                    <div className="brElement"></div>
                    <div className="brElement"></div>

                    <Link to="/footerNavPage5" target='_blank'>

                        KiCADからのガーバー出力方法
                    </Link>
                    <div className="brElement"></div>
                    <div className="brElement"></div>

                    <Link to="/footerNavPage3" target='_blank'>

                        EAGLEからのガーバー出力方法
                    </Link>
                    <div className="brElement"></div>
                    <div className="brElement"></div>

                    <Link to="/footerNavPage2" target='_blank'>

                        Altiumからのガーバー出力方法
                    </Link>
                    <div className="brElement"></div>
                    <div className="brElement"></div>

                    <Link to="/footerNavPage6" target='_blank'>

                        OrCADからのガーバー出力方法
                    </Link>
                    <div className="brElement"></div>
                    <div className="brElement"></div>

                    <Link to="/footerNavPage1" target='_blank'>

                        Allegroからのガーバー出力方法
                    </Link>
                    <div className="brElement"></div>
                    <div className="brElement"></div>

                    <div className='col-md-10'></div>
                    <div className='col-md-2 col-12-custom'>
                        <Link to="/datacreationandUploadTopic">
                            <span className='font-size-20'>
                            戻る
                            </span>
                        </Link>
                    </div>

                </div>
            </div>
        );
    }
}

export default DataCreationAndUpload;




// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/FaqPages/DataCreationAndUpload.js